import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { cssMainSelector } from "../lib/cssSelectors";
import { withTranslation } from "react-i18next";
import { Label } from "./Label";
import styled, { css } from "styled-components";

const countPadding = css `padding: ${p => p.theme.spacing.xxs} ${p => p.theme.spacing.xs}`;
const Count = styled(Label)`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.color.darkSlateGray};
    border: 1px ${p => p.theme.color.darkSlateGray} solid;
    border-radius: ${p => p.theme.generic.borderRadius};
    background-color: ${p => p.theme.color.white};
    font-size: ${p => p.theme.font.sizeXs};
    font-weight: ${p => p.theme.font.weightNormal};
    line-height: 13px;
    ${countPadding};
  }
`;

class PhoneSimCountLabel extends PureComponent {
  render() {
    const text = this.text();

    if (text) {
      return <Count {...this.props}>{text}</Count>;
    } else {
      return null;
    }
  }

  text() {
    const { count, t } = this.props;

    switch (count) {
      case 1:
        return null;
      case 2:
        return t("dualSim");
      case 3:
        return t("tripleSim");
      case 4:
        return t("quadSim");
      default:
        return null;
    }
  }
}

PhoneSimCountLabel.propTypes = {
  count: PropTypes.number.isRequired
};

export default withTranslation(["phoneSimCountLabel"])(PhoneSimCountLabel);
